export const mapCustomersWithGdap = (customers, relationships, assignments) => {
  // Attach access assignments to each relationship by matching its id from @odata.context in batch responses
  const relationshipsWithAssignments = relationships.map(rel => {
    const matchedAssignments = assignments.flatMap(r => {
      try {
        const context = r.body?.['@odata.context']
        const id = context?.toString().split("'")[1]
        if (id === rel.id) return r?.body?.value || []
        return []
      } catch (_) {
        return []
      }
    })
    return { ...rel, assignments: matchedAssignments }
  })

  // Seed map with Partner Center customers; mark partnerCenter = true
  const byTenantId = new Map(
    (Array.isArray(customers) ? customers : []).map(c => [c.id, { ...c, partnerCenter: true }])
  )

  // Ensure tenants from GDAP relationships exist; create minimal entries when missing
  relationshipsWithAssignments.forEach(rel => {
    const tenantId = rel?.customer?.tenantId
    if (!tenantId) return
    if (!byTenantId.has(tenantId)) {
      byTenantId.set(tenantId, {
        id: tenantId,
        companyProfile: {
          companyName: (rel?.customer?.displayName || rel?.displayName || 'Unknown'),
          domain: '',
          tenantId,
        },
        partnerCenter: false,
      })
    }
  })

  // Merge GDAP data into all tenants (both Partner Center and GDAP-only)
  const merged = Array.from(byTenantId.values()).map(tenant => {
    const tenantRelationships = relationshipsWithAssignments.filter(r => r?.customer?.tenantId === tenant.id)

    const allowDelegatedAccess = tenantRelationships.some(r => r?.status === 'active')

    const unifiedRoles = []
    tenantRelationships.forEach(r => {
      const roles = r?.accessDetails?.unifiedRoles || []
      roles.forEach(role => {
        if (!unifiedRoles.some(x => x.roleDefinitionId === role.roleDefinitionId)) {
          unifiedRoles.push(role)
        }
      })
    })

    return {
      ...tenant,
      allowDelegatedAccess,
      unifiedRoles,
      endDateTime: tenantRelationships[0]?.endDateTime || null,
      autoExtendDuration: tenantRelationships[0]?.autoExtendDuration || null,
      assignments: tenantRelationships[0]?.assignments || [],
      relationshipId: tenantRelationships[0]?.id || null,
      eTag: tenantRelationships[0]?.['@odata.etag'] || null,
    }
  })

  return merged
}
